import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var getRTLStyle = function getRTLStyle(_ref) {
  var _ref2;
  var componentCls = _ref.componentCls,
    menuArrowOffset = _ref.menuArrowOffset,
    calc = _ref.calc;
  return _ref2 = {}, _defineProperty(_ref2, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_ref2, "".concat(componentCls, "-submenu-rtl"), {
    transformOrigin: '100% 0'
  }), _defineProperty(_ref2, "".concat(componentCls, "-rtl").concat(componentCls, "-vertical,\n    ").concat(componentCls, "-submenu-rtl ").concat(componentCls, "-vertical"), _defineProperty({}, "".concat(componentCls, "-submenu-arrow"), {
    '&::before': {
      transform: "rotate(-45deg) translateY(".concat(unit(calc(menuArrowOffset).mul(-1).equal()), ")")
    },
    '&::after': {
      transform: "rotate(45deg) translateY(".concat(unit(menuArrowOffset), ")")
    }
  })), _ref2;
};
export default getRTLStyle;